<template>
  <div class="c-coins-count">
    <div class="c-coins-count__icon" v-html="coinsIcon"></div>
    <div class="c-coins-count__sum">{{ coins }}</div>
  </div>
</template>

<script>
import coinsIcon from "@/assets/svg/rebuild/coins_icon.svg";
export default {
  name: "CoinsCount",
  props: ["coins"],
  data() {
    return {
      coinsIcon
    };
  }
};
</script>

<style lang="scss" scoped>
.c-coins-count {
  display: flex;
  align-items: flex-end;
  border-radius: 10px;
  background-color: #dde0fa;
  padding: 3px 10px;
  @media (min-width: 767px) {
    padding: 5px 25px;
    border-radius: 25px;
  }
}

.c-coins-count__sum {
  font-weight: bold;
  margin-left: 2px;
}
</style>
